import React from 'react';

import { getRunAnswerCount } from '@aline/common/question-plan';
import { Typography } from '@mui/material';
import { getTypographyForSx } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

import { formatCount } from './question-plan-helpers';
import type { QuestionPlanRunCounts } from './question-plan-helpers';

const useStyles = makeStyles()(theme => ({
  summary: {
    ...getTypographyForSx(theme.typography.body2),
    color: theme.appColors.secondaryType,
    fontSize: 12,
  },
}));

/** "143 documents · 2 questions · 286 answers": what a run will cost before it starts. */
export const RunSummary = React.memo(function RunSummary({
  documentCount,
  questionCount,
}: QuestionPlanRunCounts) {
  const { classes } = useStyles();
  const answerCount = getRunAnswerCount({ documentCount, questionCount });
  return (
    <Typography className={classes.summary}>
      {formatCount(documentCount, 'document')} · {formatCount(questionCount, 'question')} ·{' '}
      <b>{formatCount(answerCount, 'answer')}</b>
    </Typography>
  );
});
